module.exports = __webpack_public_path__ + "media/angular-engine/app/signup/setup-account/setup-8f889618ebd18ca84318ca2de8da072c.svg";